import { addPosition, removeItems } from '../../utils/continueWatchingUtils';
import { continueWatchingItemsSelector } from '../../reducers/continueWatching';
import { loadPersistentActions } from '../../utils/persistentState';

// Only use one action type so we get only one action sent when getting state from persistent storage
export const UPDATE_CONTINUE_WATCHING_ITEMS = 'CONTINUE_WATCHING';

export function clearVideoPositions() {
    return setContinueWatchingItems([]);
}

export function deleteContinueWatchingListContents(deletedItems) {
    return (dispatch, getState) => {
        if (deletedItems && deletedItems.length > 0) {
            const items = removeItems(continueWatchingItemsSelector(getState()).toJS(), deletedItems);
            dispatch(setContinueWatchingItems(items));
        }
    };
}

export function addVideoPosition(barn, svtId, titleArticleId, __typename, position, videoLength) {
    return (dispatch, getState) => {
        // Make sure that we do not overwrite state if that state is just in local storage. This will
        // happen if we for instance have different tabs open with different episodes.
        loadPersistentActions(dispatch, UPDATE_CONTINUE_WATCHING_ITEMS);

        const continueWatchingItems = continueWatchingItemsSelector(getState()).toJS();
        const items = addPosition(
            barn,
            continueWatchingItems,
            svtId,
            titleArticleId,
            __typename,
            position,
            videoLength
        );
        dispatch(setContinueWatchingItems(items));
    };
}

function setContinueWatchingItems(items) {
    return {
        type: UPDATE_CONTINUE_WATCHING_ITEMS,
        payload: { items: items },
        persistent: true,
    };
}

export function continueWatchingActiveSave(active) {
    return {
        type: UPDATE_CONTINUE_WATCHING_ITEMS,
        payload: { active: active },
        persistent: true,
    };
}
